export default "/_next/static/images/2021-2x-ef468201203d6fbd1e6cd536955f356f.png";